<template>
  <div class="custom-container">
    <div class="wrapper">
      <h1>Privacy Policy</h1>
      <p>1. Data Collection:&nbsp;</strong>During the use of this site, we will collect access data without direct personal reference, such as the name of the internet service provider, the site you used when visiting us, the IP addresses and the names of the requested files. The authority responsible for your data can be found at the end of this declaration. If you send us your personal information (for example, when using the feedback function), the collection, development, use and transmission of this data will only take place to the extent necessary for the request or service to be fulfilled. However, we will not pass this personal information on to third parties for advertising purposes.</p>

      <p>2. Cookies:</strong>&nbsp;Bunun yanı sıra, bu çerezlerden daha sonraki bir tarihte bilgiler elde etmek suretiyle sitedeki geziniminizi kolaylaştırmak amacıyla bilgisayarınıza çerezler (küçük boyutlu dosyalar) yerleştirilecektir. Bilgisayarınızı, depolanmadan önce sizin onayınızı isteyecek şekilde ayarlayarak bilgisayarınızda çerezlerin depolanmasını engelleyebilirsiniz. Ayrıca depolanan çerezleri istediğiniz anda silebilirsiniz. Tarayıcınızın kullanma kılavuzunda daha fazla bilgi bulabilirsiniz. Çerezlerin yerleştirilmesini kabul etmezseniz ya da silerseniz arızalar meydana gelebilir.</p>

      <p>3. Google Analytics:</strong>&nbsp;This site is Google Inc. Uses Google Analytics, a web logical analysis service provided by ("Google"). Google Analytics uses "cookies" in the form of text files placed on your computer to help the website analyze how users use the site. Information generated by a cookie about your use of the website (including your IP address) will be transmitted to Google on servers located in the United States and stored by it. Google will use this information to evaluate your use of the website, report on website activity for website operators, and provide other services related to website activity and internet usage. Google may also transmit this information to third parties if it is required by law or if such third parties process this information on behalf of Google. Google will not associate your IP address with any other data stored by Google. You can refuse the use of cookies by choosing the appropriate settings on your browser, but please note that you may not be able to use this website in full functionality if you do so. By using this website, you consent to the processing of information about you by Google in the manner and for the purposes set out above.</p>

      <p>&nbsp;</p>
      <p></p>
    </div>

  </div>

</template>

<script>
export default {
  name: 'PrivacyPolicy',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Privacy Policy',
      link: [
        { rel: 'canonical', href: window.location.origin + '/privacy-policy/' }
      ]
    }
  },  
}

</script>

<style lang="scss">
  @import "../assets/scss/components/user-contract";
</style>
